export enum UserRoleEnum {
  SYS_HI_LVL = 'sys_hi_lvl',
  OPERATOR = 'operator'
}
